module.exports = __webpack_public_path__ + "img/symbol_2.925cb27e.png";